export default "__VITE_ASSET__DtAhRaWS__"